export { default } from './FooterTop';
